<template lang='pug'>
div.profile-form
  //Notification Alert
  Notificationalert(
    v-if="controls.alert.display" 
    v-bind:alert="controls.alert"
  )

  .tw-mb-6
    h5.h5.tw-text-gray-600.tw-mb-4 {{$I18n.t('vue.profile_form.personal_info')}}
    
    .row.mb-3
      .col-12
        label.form-label {{$I18n.t('vue.profile_form.email')}}
        input.form-control(type="text" :value="account.user.email" disabled)
        small.text-muted {{$I18n.t('vue.profile_form.email_cannot_change')}}

    .row.mb-3
      .col-md-4
        label.form-label {{$I18n.t('vue.profile_form.first_name')}} *
        input.form-control(type="text" v-model="form.first_name")
      .col-md-4
        label.form-label {{$I18n.t('vue.profile_form.middle_name')}}
        input.form-control(type="text" v-model="form.middle_name")
      .col-md-4
        label.form-label {{$I18n.t('vue.profile_form.last_name')}}
        input.form-control(type="text" v-model="form.last_name")

    .row.mb-3
      .col-12
        label.form-label {{$I18n.t('vue.profile_form.alternative_email')}}
        input.form-control(type="email" v-model="form.alternative_email" :placeholder="$I18n.t('vue.profile_form.alternative_email_placeholder')")
        small.text-muted {{$I18n.t('vue.profile_form.alternative_email_help')}}

    .row.mb-3
      .col-12
        label.form-label {{$I18n.t('vue.profile_form.role')}}
        input.form-control(type="text" :value="account.role.name" disabled)

  hr

  .tw-mb-6
    h5.h5.tw-text-gray-600.tw-mb-4 {{$I18n.t('vue.profile_form.change_password')}}
    small.text-muted.tw-block.tw-mb-3 {{$I18n.t('vue.profile_form.change_password_help')}}
    
    .row.mb-3
      .col-md-4
        label.form-label {{$I18n.t('vue.profile_form.current_password')}}
        input.form-control(type="password" v-model="form.current_password")
      .col-md-4
        label.form-label {{$I18n.t('vue.profile_form.new_password')}}
        input.form-control(type="password" v-model="form.new_password")
      .col-md-4
        label.form-label {{$I18n.t('vue.profile_form.confirm_password')}}
        input.form-control(type="password" v-model="form.new_password_confirmation")

  hr

  .tw-flex.tw-justify-end.tw-gap-2
    button.app-btn-primary(v-if="!state.sending" @click="save")
      i.fa-solid.fa-floppy-disk.tw-mr-2
      span {{$I18n.t('vue.profile_form.save')}}
    div(v-else)
      .spinner-border.spinner-border-sm(role="status")
      span.tw-ml-2 {{$I18n.t('vue.profile_form.saving')}}

</template>

<script>
import CoreComponents from "../core";
import { BackendService } from "../../services";

export default {
  props: ["dataAccount"],
  components: { ...CoreComponents },
  data: function () {
    const account = JSON.parse(this.dataAccount);
    return {
      account: account,
      form: {
        first_name: account.person.first_name,
        middle_name: account.person.middle_name,
        last_name: account.person.last_name,
        alternative_email: account.user.alternative_email || '',
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      state: {
        sending: false
      },
      controls: {
        alert: {
          display: false,
          type: "",
          notice: "",
          message: "",
          link: {
            text: "",
            href: ""
          }
        }
      }
    };
  },
  methods: {
    save: function () {
      const self = this;
      
      // Validate
      if (!this.form.first_name || this.form.first_name.trim() === '') {
        this.showError('vue.profile_form.errors.first_name_required');
        return;
      }

      // Validate password fields if any is filled
      if (this.form.new_password || this.form.current_password) {
        if (!this.form.current_password) {
          this.showError('vue.profile_form.errors.current_password_required');
          return;
        }
        if (!this.form.new_password) {
          this.showError('vue.profile_form.errors.new_password_required');
          return;
        }
        if (this.form.new_password !== this.form.new_password_confirmation) {
          this.showError('vue.profile_form.errors.password_mismatch');
          return;
        }
        if (this.form.new_password.length < 8) {
          this.showError('vue.profile_form.errors.password_too_short');
          return;
        }
      }

      this.state.sending = true;
      this.controls.alert.display = false;

      BackendService.update_profile(this.form)
        .then((r) => {
          if (r.isOk) {
            self.showSuccess('vue.profile_form.results.profile_updated_ok');
            // Clear password fields
            self.form.current_password = '';
            self.form.new_password = '';
            self.form.new_password_confirmation = '';
          } else {
            self.showError('vue.profile_form.results.' + r.notice.toLowerCase());
          }
        })
        .catch(() => {
          self.showError('vue.profile_form.errors.error_promise');
        })
        .finally(() => {
          self.state.sending = false;
        });
    },
    showError: function (notice) {
      this.controls.alert.type = "danger";
      this.controls.alert.notice = notice;
      this.controls.alert.message = 'vue.empty';
      this.controls.alert.link.text = 'vue.empty';
      this.controls.alert.link.href = '';
      this.controls.alert.display = true;
    },
    showSuccess: function (notice) {
      this.controls.alert.type = "success";
      this.controls.alert.notice = notice;
      this.controls.alert.message = 'vue.empty';
      this.controls.alert.link.text = 'vue.empty';
      this.controls.alert.link.href = '';
      this.controls.alert.display = true;
    }
  }
};
</script>
